export default "__VITE_ASSET__DB6Ph6fN__"